import type { SerializedStyles } from '@emotion/react';
import {
  Title as DSTitle,
  Group,
  type GroupProps,
  Text,
  desktopFirstMediaQuery,
} from '@inflearn/ds-react';
import { useTranslation } from 'next-i18next';
import type { ReactNode } from 'react';

import { formatCommaNumber } from '../../../../utils/format/number';

export default function SectionHeader({
  children,
  styles,
  align = 'start',
  position = 'apart',
}: {
  children: ReactNode;
  styles?: SerializedStyles;
  position?: GroupProps['position'];
  align?: GroupProps['align'];
}) {
  return (
    <Group
      noWrap
      mb={12}
      align={align}
      position={position}
      css={[
        {
          marginTop: 20,
          [desktopFirstMediaQuery.tablet]: {
            marginTop: 0,
          },
          [desktopFirstMediaQuery.mobile]: {
            gap: 10,
            marginTop: 20,
          },
        },
        styles,
      ]}
    >
      {children}
    </Group>
  );
}

function Title({ title, children }: { title: string; children?: ReactNode }) {
  if (!children) {
    return (
      <DSTitle
        order={2}
        size={20}
        css={{
          whiteSpace: 'nowrap',
          [desktopFirstMediaQuery.mobile]: {
            fontSize: 18,
          },
        }}
      >
        {title}
      </DSTitle>
    );
  }

  return (
    <Group noWrap miw={0} spacing={0}>
      <DSTitle
        order={2}
        size={20}
        css={{
          whiteSpace: 'nowrap',
          [desktopFirstMediaQuery.mobile]: {
            fontSize: 18,
          },
        }}
      >
        {title}
      </DSTitle>
      {children}
    </Group>
  );
}

function TotalCount({ totalCount }: { totalCount: number }) {
  const { t } = useTranslation();

  return (
    <Text ml={8} size="sm" weight={500} color="gray.7" component="span">
      {t('전체', { context: 'TOTAL' })}{' '}
      <Text component="b" weight={700} color="infgreen.6" ml={2}>
        {formatCommaNumber(totalCount)}
      </Text>
    </Text>
  );
}

SectionHeader.Title = Title;
SectionHeader.TotalCount = TotalCount;
